module.exports = __webpack_public_path__ + "img/crown.b8287b24.png";